import { render } from "./BacklinksView.vue?vue&type=template&id=d814c546&scoped=true"
import script from "./BacklinksView.vue?vue&type=script&lang=js"
export * from "./BacklinksView.vue?vue&type=script&lang=js"

import "./BacklinksView.vue?vue&type=style&index=0&id=d814c546&lang=css"
import "./BacklinksView.vue?vue&type=style&index=1&id=d814c546&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d814c546"]])

export default __exports__